import { FC } from 'react'
import { PerSpacerProps } from '../Spacer'
import { marginClasses } from '../../util/less-util'
import '../Text/index.less'
import { useTranslation } from 'react-i18next'
import PerText, { PerTextProps } from '../Text'
import { DropzoneRootProps, useDropzone } from 'react-dropzone'
import PerFlexRow from '../FlexRow'
import classNames from 'classnames'
import './index.less'

export interface PerDropzoneProps extends PerSpacerProps {
  header?: string
  headerProps?: PerTextProps
  headerClassNames?: string[]
  errorText?: string
  errorTextProps?: PerTextProps
  errorTextClassNames?: string[]
  footerText?: string
  footerTextProps?: PerTextProps
  footerTextClassNames?: string[]
  dropzoneProps?: DropzoneRootProps
  variant?: 'pastel'
  size?: 'small'
  width?: 'fullWidth' | string
  shadow?: boolean
  disabled?: boolean
  className?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFileDropped: (file: unknown) => void
  maxAllowedSize: number
  error?: string
}

const PerDropzone: FC<PerDropzoneProps> = ({
  header,
  headerProps,
  headerClassNames,
  errorText,
  errorTextProps,
  errorTextClassNames,
  footerText,
  footerTextProps,
  footerTextClassNames,
  dropzoneProps,
  variant,
  size,
  width,
  shadow,
  className,
  onFileDropped,
  maxAllowedSize,
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml,
}) => {
  const [t] = useTranslation()
  const dnd = 'per-dnd'
  const modifiers = marginClasses(m, mb, mt, ml, mr, mx, my, 'per-spacer')

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop: ([file]) => onFileDropped(file),
    multiple: false,
    maxSize: maxAllowedSize,
  })

  if (variant) {
    modifiers.push(`${dnd}--${variant}`)
  }
  if (size) {
    modifiers.push(`${dnd}--${size}`)
  }
  if (width) {
    modifiers.push(`${dnd}--${width}`)
  }
  if (shadow) {
    modifiers.push(`${dnd}--shadow`)
  }
  if (className) {
    modifiers.push(className)
  }

  const isFileTooLarge = fileRejections.length > 0 && fileRejections[0].file.size > maxAllowedSize

  return (
    <>
      <PerFlexRow>
        <PerFlexRow>
          {header && (
            <PerText {...headerProps} className={classNames(headerClassNames)}>
              {header}
            </PerText>
          )}
        </PerFlexRow>
        <PerFlexRow width="fullWidth">
          <PerFlexRow width={width}>
            {dropzoneProps && (
              <div {...dropzoneProps} className="dropzone">
                <input {...getInputProps()} />
                {isDragActive ? <p>{t('okr.objective.modal.dropzoneHovered')}</p> : <p>{t('okr.objective.modal.dropzone')}</p>}
                {isFileTooLarge && (
                  <PerText {...errorTextProps} className={classNames(errorTextClassNames)}>
                    {t('okr.objective.modal.tooLarge')}
                  </PerText>
                )}
                {!isFileTooLarge && errorText && (
                  <PerText {...errorTextProps} className={classNames(errorTextClassNames)}>
                    {errorText}
                  </PerText>
                )}
              </div>
            )}
            {!dropzoneProps && (
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                {isDragActive ? <p>{t('okr.objective.modal.dropzoneHovered')}</p> : <p>{t('okr.objective.modal.dropzone')}</p>}
                {isFileTooLarge && (
                  <PerText {...errorTextProps} className={classNames(errorTextClassNames)}>
                    {t('okr.objective.modal.tooLarge')}
                  </PerText>
                )}
                {!isFileTooLarge && errorText && (
                  <PerText {...errorTextProps} className={classNames(errorTextClassNames)}>
                    {errorText}
                  </PerText>
                )}
              </div>
            )}
          </PerFlexRow>
        </PerFlexRow>
        <PerFlexRow width="fullWidth">
          <PerFlexRow width={width}>
            <PerText {...footerTextProps} className={classNames(footerTextClassNames)}>
              {footerText}
            </PerText>
          </PerFlexRow>
        </PerFlexRow>
      </PerFlexRow>
    </>
  )
}

export default PerDropzone
